module.exports = __webpack_public_path__ + "static/media/BBMP.5ac893e5.pdf";